import { Geojson } from "../taskmap.types";

export function getSortedData(geojson: Geojson, productKey: string) {
  return geojson.features
    .map((f) => f.properties[productKey])
    .filter((v) => v != null)
    .map(Number)
    .sort((a, b) => a - b);
}

export function getCutoffs(sortedData: number[]) {
  if (sortedData.length === 0) return { min: 0, max: 0 };
  return {
    min: Math.floor(sortedData[Math.floor(sortedData.length / 2)]),
    max: Math.ceil(sortedData[sortedData.length - 1]),
  };
}
